<app-evida-error icon="evida_error_locked" [showRetryButton]="false" [showCorrelationId]="false">
    <div class="flex flex-col mb-20px">
        <h2 class="header-medium" translate="shared.errormessages.status410.title"></h2>
        <span translate="shared.errormessages.status410.description"></span>
    </div>
    <app-evida-button type="primary" (clicked)="onGoBack()">
        {{ 'shared.buttons.back' | translate }}
    </app-evida-button>
</app-evida-error>
